var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106.645,
    height: 119.745,
    viewBox: "0 0 106.645 119.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(-1028 -364.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person_12636556",
    transform: "translate(1028 364.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M65.736,63.194H96.923a32.153,32.153,0,0,1,32.115,32.119v14.823a4.008,4.008,0,0,1-4,4H111.18V92.267a2.807,2.807,0,1,0-5.613,0v21.872H57.092V92.267a2.807,2.807,0,1,0-5.613,0v21.872H37.622a4.009,4.009,0,0,1-4-4V95.312A32.153,32.153,0,0,1,65.736,63.193ZM28.007,95.312v14.823a9.628,9.628,0,0,0,9.615,9.617h87.415a9.628,9.628,0,0,0,9.615-9.617V95.312A37.829,37.829,0,0,0,96.923,57.581H65.736A37.833,37.833,0,0,0,28.007,95.312ZM59.71,27.24A21.62,21.62,0,1,1,81.33,48.861,21.62,21.62,0,0,1,59.71,27.24Zm48.853,0A27.233,27.233,0,1,0,81.329,54.474,27.233,27.233,0,0,0,108.563,27.24Z",
    transform: "translate(-28.007 -0.008)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M55.5,36.433c-.011-.009-.023-.014-.036-.023-.038-.034-.081-.061-.121-.092-.063-.045-.13-.088-.2-.128-.043-.027-.085-.056-.13-.081s-.085-.038-.125-.058c-.07-.032-.141-.058-.213-.085-.051-.02-.1-.042-.153-.058s-.087-.02-.128-.031c-.072-.018-.146-.031-.22-.041-.054-.009-.108-.022-.162-.027s-.1,0-.15-.005-.072-.011-.11-.011-.072.009-.11.011-.1,0-.15.005-.108.018-.162.027c-.074.013-.148.025-.22.041-.042.011-.087.018-.128.031s-.1.038-.153.058c-.072.027-.143.052-.213.085-.04.02-.083.038-.124.058s-.087.054-.132.081c-.067.04-.132.083-.193.128-.041.031-.085.058-.123.092-.013.009-.025.014-.036.023L41.145,45.608a2.705,2.705,0,1,0,3.491,4.134l6.411-5.415V64.665a2.706,2.706,0,0,0,5.413,0V44.328l6.411,5.415a2.705,2.705,0,1,0,3.491-4.134Z",
    transform: "translate(1027.569 404.457)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.687cdf2087b8c496ca1777fab8ca5947.svg";
export { ForwardRef as ReactComponent };